/**
 * @fileoverview The i18next namespace the shell-string bundles register under.
 * @package @puffin-core/page-shell
 *
 * A ZERO-IMPORT leaf module, deliberately. `useShellTranslation()` is imported by
 * ~50 shell components; routing it through `strings/index.js` would drag `en.js`,
 * `es.js` and `en-XA.js` into every one of those import chains for the sake of
 * a five-character constant. The barrel re-exports this so `SHELL_NAMESPACE`
 * keeps its single public import site.
 */

/**
 * The canonical namespace under which shell strings live in i18next.
 * `useShellTranslation()` returns a `t` pre-bound to it.
 */
export const SHELL_NAMESPACE = 'shell';

export default SHELL_NAMESPACE;
